import { Injectable } from '@angular/core';
import { ConfigService } from "../../app/Services/config.service";
import { HttpServiceService } from "../../app/Services/http-service.service";
import { StorageMap } from "@ngx-pwa/local-storage";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private config:ConfigService, private http:HttpServiceService) { }

  public GetInboxMessagesURL="Notification/GetInboxMessages";
  public DeleteInboxMessageURL="Notification/DeleteInboxMessage";
  public InboxMessageReadURL="Notification/InboxMessageRead";
  

  GetInboxMessages(body, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.GetInboxMessagesURL, body, token)
        .subscribe(
          (res: any) => {
            if (res.response) {
              if (res.response.code) {
                if (res.response.code == 1) {
                }
              }
            }
            resolve(res);
            console.log('GetInboxMessages',res);
          },
          (Error) => {
            resolve(Error);
            console.log('GetInboxMessagesError',Error);

          }
        );
    });
  }  

  DeleteInboxMessage(body, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.DeleteInboxMessageURL, body, token)
        .subscribe(
          (res: any) => {
            if (res.response) {
              if (res.response.code) {
                if (res.response.code == 1) {
                }
              }
            }
            resolve(res);
            console.log('DeleteInboxMessage',res);
          },
          (Error) => {
            resolve(Error);
            console.log('DeleteInboxMessageError',Error);

          }
        );
    });
  }  
  InboxMessageRead(body,token){
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.InboxMessageReadURL, body, token)
        .subscribe(
          (res: any) => {
            if (res.response) {
              if (res.response.code) {
                if (res.response.code == 1) {
                }
              }
            }
            resolve(res);
            console.log('InboxMessageRead',res);
          },
          (Error) => {
            resolve(Error);
            console.log('InboxMessageReadError',Error);

          }
        );
    });

  }


  
}
